<template>
  <el-dialog
    :title="title"
    :visible="true"
    width="1200px"
    :close-on-click-modal="false"
    :before-close="handleClose"
  >
    <el-form
      ref="representativeFormForm"
      v-loading="loading"
      :model="representativeForm"
      :rules="rules"
      label-position="top"
      autocomplete="off"
      style="margin-bottom: 30px;"
      @submit.native.prevent="store"
    >
      <el-switch
        v-model="representativeForm.is_active"
        active-text="Aktív"
        inactive-text="Inaktív"
        style="margin-bottom: 20px;"
      />
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            prop="name"
            label="Nyomtatvány neve"
          >
            <el-input
              v-model="representativeForm.name"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            prop="type"
            label="Típus"
          >
            <el-select
              v-model="representativeForm.type"
              style="width: 100%"
            >
              <el-option
                label="Általános"
                value="common"
              >
                Általános
              </el-option>
              <el-option
                label="Üzlethez rendelt"
                value="shop"
              >
                Üzlethez rendelt
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <Builder
      v-if="representativeForm && representativeForm.delta"
      ref="builder"
      :data="JSON.parse(representativeForm.delta)"
      :type="representativeForm.type"
    />
    <div
      slot="footer"
      class="dialog-footer"
    >
      <div>
        <el-button @click="handleClose">
          Mégse
        </el-button>
        <el-button
          type="primary"
          :loading="buttonLoading"
          @click="store"
        >
          {{ buttonText }}
        </el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
  import Builder from './Builder/Builder';
  import { VueEditor } from 'vue2-editor';
  import { QuillDeltaToHtmlConverter } from 'quill-delta-to-html';

  export default {
    components: { Builder },
    props: ['type', 'representativeFormId'],
    data() {
      return {
        loading: false,
        buttonLoading: false,
        representativeForm: {
          is_active: true,
        },
        rules: {
          name: [
            {
              required: true,
              message: 'Mező kitöltése kötelező',
              trigger: 'blur'
            }
          ],
        },
      };
    },
    computed: {
      title() {
        if (this.type === 'add') {
          return 'Új nyomtatvány';
        } else if (this.type === 'update') {
          return 'Nyomtatvány módosítása';
        } else {
          return '';
        }
      },
      buttonText() {
        if (this.type === 'add') {
          return 'Hozzáadása';
        } else if (this.type === 'update') {
          return 'Módosítás';
        } else {
          return '';
        }
      },
    },
    async mounted() {
      this.loading = true;
      if (this.representativeFormId) {
        this.representativeForm = await this.$store.dispatch('representativeForm/fetch', this.representativeFormId);
      } else {
        this.representativeForm.delta = '[]';
      }
      this.loading = false;
    },
    methods: {
      handleClose() {
        this.$confirm('Biztosan elveted a módosításokat?', {
          confirmButtonText: 'Igen',
          type: 'warning',
        })
        .then(() => {
          this.$router.replace('/representative-processes/representative-forms');
        })
        .catch(() => {
        });
      },
      async store() {
        this.$refs['representativeFormForm'].validate(async valid => {
          if (valid) {
            this.buttonLoading = true;
            try {
              let fullHTML = '';
              const rows = this.$refs.builder.rows;
              rows.forEach(row => {
                if (row.columns.length > 1) {
                  fullHTML += '<table class="row-table">';
                  fullHTML += '<tr>';
                } else {
                  // fullHTML += '<div class="row">';
                }
                row.columns.forEach(column => {
                  if (row.columns.length > 1) {
                    fullHTML += `<td>`;
                  }
                  column.contents.forEach(content => {
                    const qdc = new QuillDeltaToHtmlConverter(content.value.ops, window.opts_ || {
                      paragraphTag: 'p',
                    });
                    qdc.renderCustomWith(function(customOp, contextOp) {
                      if (customOp.insert.type === 'TemplateMarker') {
                        const val = customOp.insert.value;
                        return `{% ${val.marker} %}`;
                      }
                    });
                    fullHTML += qdc.convert();
                  });
                  if (row.columns.length > 1) {
                    fullHTML += `</td>`;
                  }
                });
                if (row.columns.length > 1) {
                  fullHTML += '</tr>';
                  fullHTML += '</table>';
                } else {
                  // fullHTML += "</br>";
                }
              });
              const data = {
                id: this.representativeForm.id,
                name: this.representativeForm.name,
                is_active: this.representativeForm.is_active,
                type: this.representativeForm.type,
                delta: JSON.stringify(rows),
                html: fullHTML,
              };
              if (this.type === 'add') {
                await this.$store.dispatch('representativeForm/create', data);
              } else {
                await this.$store.dispatch('representativeForm/update', data);
              }
              this.$store.dispatch('representativeForm/fetchAll');
              this.$router.replace('/representative-processes/representative-forms');
            } catch (e) {
            }
            this.buttonLoading = false;
          }
        });
      },
    }
  };
</script>
